"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetKind = exports.Bet = void 0;
const class_transformer_1 = require("class-transformer");
class Bet {
    constructor(amount, kind) {
        this.amount = amount;
        this.kind = kind;
    }
}
__decorate([
    class_transformer_1.Transform(({ value }) => BetKind[value.toUpperCase()]),
    __metadata("design:type", String)
], Bet.prototype, "kind", void 0);
exports.Bet = Bet;
var BetKind;
(function (BetKind) {
    BetKind["BET"] = "bet";
    BetKind["CALL"] = "call";
    BetKind["CHECK"] = "check";
    BetKind["RAISE"] = "raise";
    BetKind["BIGBLIND"] = "bigblind";
    BetKind["SMALLBLIND"] = "smallblind";
})(BetKind || (BetKind = {}));
exports.BetKind = BetKind;
//# sourceMappingURL=Bet.js.map